import React, { useEffect, useState } from "react";
import CertificateDocument from "../components/CertificateDocument";

export const PREVIEW_STORAGE_KEY = "tuvpak_certificate_preview";

// Opened in a new tab from Create Certificate. Shows the data currently
// entered in the form, laid out the same way as the generated PDF.
const CertificatePreviewPage = () => {
  const [doc, setDoc] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(PREVIEW_STORAGE_KEY);
      setDoc(raw ? JSON.parse(raw) : null);
    } catch {
      setDoc(null);
    }
  }, []);

  if (!doc) {
    return (
      <div className="cc-print-page">
        <p className="cc-print-empty">No certificate data to preview. Go back to Create Certificate and open the preview again.</p>
      </div>
    );
  }

  return (
    <div className="cc-print-page">
      <CertificateDocument doc={doc} />
    </div>
  );
};

export default CertificatePreviewPage;
